import { jsonp } from './jsonp';
import { getCToken } from './getCookieInfo';

interface PropType {
  code: number;
  data: { [key: string]: string };
  message: string;
  result: boolean;
}
export const checkFavorite = (pid: number) => {
  return jsonp(
    `//us-favorite.alibaba.com/favorite2/ajax/checkFavorites.htm?pids=${pid}&ctoken=${getCToken()}`,
  ).then((res: PropType) => {
    if (res?.result === true && res?.data) {
      const { data } = res;
      return {
        isFavorite: data[pid],
      };
    } else {
      return { message: res?.message };
    }
  });
};

export const addFavorite = (pid: number) => {
  return jsonp(
    `//hz-favorite.alibaba.com/favorite2/ajax/addFavorite.htm?pid=${pid}&ctoken=${getCToken()}`,
  ).then((res: PropType) => {
    if (res.result === true) {
      return { success: true };
    } else {
      return { message: res?.message };
    }
  });
};

export const removeFavorite = (pid: number) => {
  return jsonp(
    `//us-favorite.alibaba.com/favorite2/ajax/deleteFavorite.htm?pids=${pid}&ctoken=${getCToken()}`,
  ).then((res: PropType) => {
    if (res.result === true) {
      return { success: true };
    } else {
      return { message: res?.message };
    }
  });
};
